import { useEffect, useMemo } from 'react'

import { useOpenWindow } from '@krp/client-runtime'
import { PLATFORM_WINDOWS, PhotoSearchScreen, scanSessionStarted, type SearchActions } from '@krp/platform-ui'

import { useAppDispatch } from '../../app/hooks'
import { SearchTimingsBinding } from './SearchTimingsBinding'
import { usePhotoSearch } from './usePhotoSearch'
import { productPhotoUrl } from './useProductLinks'
import { useScanFlow } from './useScanFlow'

/**
 * Binding поиска по фото: экран, вход в сканер (RP-FB4) и карточка найденного товара (RP-FB14). Ответ несёт вердикт (RP-FB56):
 * «Создать новый» и «Прикрепить фото» открывают окна поверх экрана, а «Фото прикреплено к …» остаётся строкой под шапкой.
 */
export function PhotoSearchBinding() {
  const { vm, actions, sentShot } = usePhotoSearch()
  const dispatch = useAppDispatch()
  const openWindow = useOpenWindow()
  const answer = vm.outcome.kind === 'verdict' ? vm.outcome : null
  const flow = useScanFlow(answer?.hints ?? null, answer?.searchId ?? null)
  // Экран поиска начинает свою смену заново: строка «Фото прикреплено к …» не должна остаться от прошлого раза.
  useEffect(() => {
    dispatch(scanSessionStarted())
  }, [dispatch])
  const withScanner = useMemo<SearchActions>(
    () => ({ ...actions, openScanner: () => openWindow(PLATFORM_WINDOWS.scanner), verdict: flow.verdict }),
    [actions, flow.verdict, openWindow],
  )
  return (
    <PhotoSearchScreen
      vm={vm}
      actions={withScanner}
      photoUrl={productPhotoUrl}
      onOpenProduct={flow.openProduct}
      sentShot={sentShot}
      session={flow.session}
      detailsExtra={<SearchTimingsBinding searchId={answer?.searchId ?? null} />}
    />
  )
}
